import { pathOr } from "ramda";
import { Restaurant } from "src/MyRestaurant/Models/Restaurant";
import { LocalStorageKeys } from "../Enums/LocalStorageKeys";

export const getToken = () => {
    const token = localStorage.getItem("token");
    return token;
};

export const getSessionToken = () => {
    const sessionToken = localStorage.getItem("sessionToken");
    return sessionToken;
};

export const getProfile = () => {
    // @ts-ignore
    const profile = JSON.parse(localStorage.getItem("profile"));
    return profile;
};

export const getRestuarantRefId = () => {
    // @ts-ignore
    const data = JSON.parse(localStorage.getItem("restaurant"));
    return pathOr("", [0, "refId"], data);
};

export const setSelectedRestaurantTop = (
    selectedRestaurant: Restaurant,
    restaurants: Restaurant[]
) => {
    if (selectedRestaurant && restaurants) {
        // Find index from restaurant array with selected restaura
        // remove that parituclar index from restaurant array
        // set the selected restaurant at top of the restaurants array
        // then set that restaurant array in localstorage in restaurat key

        const findCurrentRestaurant = restaurants?.findIndex((item) => {
            return item?.refId === selectedRestaurant?.refId;
        });
        const removeCurrentRestaurant = restaurants.filter((item, index) => {
            return index !== findCurrentRestaurant;
        });
    }
};

export const setNewrestaurantToken = (selectedRestaurant: Restaurant) => {
    const getNewToken = selectedRestaurant.authToken;
    localStorage.setItem(LocalStorageKeys.AuthToken, getNewToken ?? "");
};

export const tokenPresent = () => {
    const token = localStorage.getItem("token");
    if (token == "" || token == undefined || token == null) {
        return false;
    } else {
        return true;
    }
};

export const getResDetails = () => {
    // @ts-ignore
    const restaurent = JSON.parse(localStorage.getItem("restaurant"));
    return restaurent[0];
};
export const getPWADisplayMode = () => {
    const isStandalone = window.matchMedia(
        "(display-mode: standalone)"
    ).matches;

    if (document.referrer.startsWith("android-app://")) {
        return "twa";
    } else if (isStandalone) {
        return "standalone";
    }
    return "browser";
};
